module.exports = __webpack_public_path__ + "media/images/ic_lit_appoint-f598b59f6e58c1dd2818cec5d2fc15a6.svg";